window.addEventListener('OpusCartChange', (event) => {
  console.log("OpusCartChange event triggered", event);

  setTimeout(() => {
    const productList = document.querySelector('.cd-product-list');
    const existingGiftsSection = document.querySelector('.free-gifts');

    if (productList && !existingGiftsSection) {
      productList.insertAdjacentHTML(
        "afterend",
        `<div class="grid__item medium-up--one-whole" style="margin-bottom: 20px; padding-left: 0px;">
          <style>
            .free-gifts {
              background-color: #F9EBC7;
              padding-left: 0px;
              margin: 16px 24px 0; 
              border-radius: 8px;
              text-align: center;
              box-sizing: border-box;
            }
            .free-gifts-section h3 {
              font-size: 20px;
              font-weight: bold;
              margin-bottom: 15px;
            }
            .free-gifts-items {
              display: grid;
              grid-template-columns: repeat(4, 1fr);
              gap: 0;
              width: 100%;
              box-sizing: border-box;
            }
            .gift-item {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: flex-start;
              border: 2px dashed #EBBF46;
              background-color: #fff;
              padding: 5px;
              box-sizing: border-box;
            }
            .old-price-tag {
              background-color: #EBBF46;
              color: #fff;
              text-decoration: line-through;
              padding: 2px 6px;
              font-size: 14px;
              margin-bottom: 6px;
              display: inline-block;
            }
            .gift-image {
              width: 40px;
              height: 40px;
              object-fit: contain;
              margin-bottom: 6px;
            }
            .gift-free-text {
              color: #333232;
              font-size: 14px;
              font-weight: bold;
              line-height: 1.2;
              text-align: center;
              margin-top: 4px;
            }
          </style>

          <!-- START: FREE GIFTS SECTION -->
          <div class="free-gifts">
            <h3>Free Gifts With Your Order</h3>
            <div class="free-gifts-items">
              <div class="gift-item">
                <div class="old-price-tag">$35.00</div>
                <img src="https://cdn.shopify.com/s/files/1/0682/5184/4777/files/canvas-_in_-12x16-person-6450a6eee1996_jpg_2b4ecf55-39c0-4f6b-add8-dcba90b5efb5.webp?v=1739712180" alt="Free Canvas" class="gift-image" />
                <div class="gift-free-text">FREE Custom A4 Canvas</div>
              </div>
              <div class="gift-item">
                <div class="old-price-tag">$10.00</div>
                <img src="https://cdn.shopify.com/s/files/1/0682/5184/4777/files/simpsonbg4.jpg?v=1760362673" alt="Free Background" class="gift-image" />
                <div class="gift-free-text">FREE Background</div>
              </div>
              <div class="gift-item">
                <div class="old-price-tag">$15.00</div>
                <img src="https://cdn.shopify.com/s/files/1/0682/5184/4777/files/icone-jaune-de-camion-d-expedition-et-de-livraison.png?v=1735331677" alt="Free Shipping" class="gift-image" />
                <div class="gift-free-text">FREE Shipping</div>
              </div>
              <div class="gift-item">
                <div class="old-price-tag">$10.00</div>
                <img src="https://cdn.shopify.com/s/files/1/0682/5184/4777/files/yellow-verified-sign-and-tick-18751.png?v=1735326232" alt="Free Revisions" class="gift-image" />
                <div class="gift-free-text">FREE Unlimited Revisions</div>
              </div>
            </div>
          </div>
        </div>`
      );
    }
  }, 500);
});
